import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Box from '../Box';
import { useThemeValue } from '../system';
var sizes = {
  xxs: '8px',
  xs: '10px',
  sm: '12px',
  md: '14px',
  lg: '18px',
  xl: '32px',
  xxl: '48px'
};

function Icon(_ref) {
  var as = _ref.as,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "name", "size", "color", "children"]);

  var themeProps = useThemeValue('icon');
  var pathData = useThemeValue(['icons'].concat(name.split('.')));
  var iconSize = sizes[size] || size;
  var childrenToRender = name ? /*#__PURE__*/React.createElement("path", {
    d: pathData
  }) : children;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    viewBox: "0 0 16 16",
    width: iconSize,
    height: iconSize,
    basis: iconSize,
    grow: 0,
    shrink: 0,
    fill: color,
    fillRule: "evenodd",
    children: childrenToRender
  }, themeProps, props));
}

export default Icon;